<template>
    <Modal v-on:close="() => closeModal()" :active="state.modal_active" size="4xl" style="z-index: 99999;">
        <div class="lg:flex lg:items-center lg:justify-between mb-8">
            <h3 class="text-xl leading-6 font-medium text-gray-900 text-center">Inspect Data</h3>
            <button type="button" v-on:click="() => closeModal()">
                <CrossIcon class="h-6 w-6 text-gray-400" />
            </button>
        </div>

        <div v-if="Array.isArray(models)" v-for="model in models" :key="model.name" class="mb-4">
            <h3 class="mb-1 text-md font-semibold text-gray-500">{{ `${model.name} Data` }}</h3>
            <pre v-if="model.data" class="p-4 rounded-md bg-gray-800 text-white overflow-x-auto">
                {{ model.data }}
            </pre>
            <Message v-else :active="!model.data" type="info" :heading="`No ${model.name} Data`" />
        </div>

        <slot></slot>

        <div class="mt-5 sm:mt-6">
            <Button type="button" color="gray" width="w-auto" class="mr-2" :onClick="closeModal">Close</Button>
            <Button v-if="refresh" type="button" color="blue" width="w-auto" :onClick="() => refresh()">Refresh data</Button>
            <Button v-else type="button" color="blue" width="w-auto" :disabled="true">Refresh data</Button>
        </div>
    </Modal>
</template>

<script>
import { reactive, watch, computed, ref } from 'vue'
import CrossIcon from '@ico/CrossIcon.vue'
export default {
    components: {
        CrossIcon
    },
    props: ['models', 'refresh'],
    setup() {

        const state = reactive({
            modal_active: false,
            foo: false
        })

        const openModal = () => {
            state.modal_active = true
        }

        const closeModal = () => {
            state.modal_active = false
        }

        return {
            state,
            openModal,
            closeModal
        }
    }
}
</script>